import { environment } from '@/environment.ts';

// Organizations that must never be selectable as a partner in manual or direct
// fulfillment flows. Sourced per-environment from
// `VITE_EXCLUDED_PARTNER_ORGANIZATION_IDS` (comma-separated org ids) so the
// list can differ between local/stage/prod. See CMC-1018: the "Partner Invoice"
// placeholder org (18739 in prod) was leaking into fulfillment_line_items as
// creditor/debtor, obscuring which organization actually performed the job.
export const EXCLUDED_PARTNER_ORGANIZATION_IDS: number[] = environment.EXCLUDED_PARTNER_ORGANIZATION_IDS;
